import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { Toast, Notify } from 'vant'
import { logTrace } from '@/utils'
import {
  TIME_OUT_TIME,
  TOAST_STAY_TIME,
  STATUS_CODE_OK,
  HEADER_TOKEN_NAME,
  CODE_UNAUTHORIZED,
  CODE_SERVER_500,
  UIS_AUTH_URL,
} from '@/config'
// ajax请求
const fetch = axios.create({
  baseURL: process.env.VUE_APP_BACK_END_API_PX_URL,
  withCredentials: true,
  timeout: TIME_OUT_TIME,
})
// request拦截器
fetch.interceptors.request.use(
  (config) => {
    if (config.loading) {
      Toast({
        type: 'loading',
        message: '加载中',
        overlay: true,
        forbidClick: true,
        duration: 0,
      })
    }
    if (store.getters.token) {
      config.headers[HEADER_TOKEN_NAME] = store.getters.token
    }
    if (!(config.contentType && config.contentType === 'application/json')) {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  (error) => {
    Toast.clear(true)
    Notify({
      background: '#fbeeee',
      color: '#e24140',
      message: error.message,
      duration: TOAST_STAY_TIME,
    })
    return Promise.reject(error)
  }
)
// respone拦截器
fetch.interceptors.response.use(
  (res) => {
    Toast.clear(true)
    const config = res.config
    // 日志上报
    let requestParams = {}
    const { actionTypeCode = '', actionTypeDesc = '', url = '' } = config
    if (!(config.contentType && config.contentType === 'application/json')) {
      requestParams = qs.parse(config.data)
    } else {
      requestParams = config.data
    }
    const { currentRoute } = router
    logTrace({
      prefixUrl: currentRoute.path ? currentRoute.path : '/',
      prefixUrlName: currentRoute.meta.name ? currentRoute.meta.name : '首页',
      requestUrl: url,
      rquestUrlName: actionTypeDesc,
      requestParams,
      actionType: 'request',
      actionTypeCode,
      actionTypeDesc,
    })
    // 返回之前验证
    if (res.data.code !== STATUS_CODE_OK) {
      Notify({
        background: '#fbeeee',
        color: '#e24140',
        message: res.data.data,
        duration: TOAST_STAY_TIME,
      })
    }
    return res
  },
  (err) => {
    Toast.clear(true)
    const config = err.config
    // 日志上报
    let requestParams = {}
    const { actionTypeCode = '', actionTypeDesc = '', url = '' } = config
    if (!(config.contentType && config.contentType === 'application/json')) {
      requestParams = qs.parse(config.data)
    } else {
      requestParams = config.data
    }
    const { currentRoute } = router
    logTrace({
      prefixUrl: currentRoute.path ? currentRoute.path : '/',
      prefixUrlName: currentRoute.meta.name ? currentRoute.meta.name : '首页',
      requestUrl: url,
      rquestUrlName: actionTypeDesc,
      requestParams,
      actionType: 'request',
      actionTypeCode,
      actionTypeDesc,
    })
    if (err.response) {
      if (err.response.status === CODE_UNAUTHORIZED) {
        Notify({
          background: '#fbeeee',
          color: '#e24140',
          message: err.message,
          duration: TOAST_STAY_TIME,
        })
        store.dispatch('setLogout')
        if (process.env.VUE_APP_IS_WXAUTH === 'Y') {
          window.location.replace(
            `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
              router.currentRoute.fullPath
            )}&openId=${store.getters.openId}`
          )
        } else {
          window.location.replace(
            `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
              router.currentRoute.fullPath
            )}`
          )
        }
      } else if (err.response.status === CODE_SERVER_500) {
        router.push('/500')
      } else {
        Notify({
          background: '#fbeeee',
          color: '#e24140',
          message: err.message,
          duration: TOAST_STAY_TIME,
        })
      }
    } else {
      Notify({
        background: '#fbeeee',
        color: '#e24140',
        message: err.message,
        duration: TOAST_STAY_TIME,
      })
    }
    return Promise.reject(err)
  }
)
export default fetch
